/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface ChevronExpandedIconProps {
  color?: string;
  size?: IconSize;
}
/*
 * Defines the Design Language System (DLS) Chevron Expanded Icon component.
 */
export const ChevronExpandedIcon = ({size = IconSize.medium, color = dlsColor('grey3')}: ChevronExpandedIconProps) => {
  const {iconSize} = useIconDLS({size});
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill={'none'}>
      <path fillRule="evenodd" clipRule="evenodd" d="M4 15L5.86667 16.8667L12 10.7333L18.1333 16.8667L20 15L12 7L4 15Z" fill={color} />
    </svg>
  );
};
